import { getAnalytics } from './global.analytics'
import { shouldUseSegment } from './segment.utils'

export const segmentReset = (): void => {
  if (shouldUseSegment(getAnalytics())) {
    getAnalytics().reset()
  }
}
